import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Newspaper, MessageSquare, PenLine } from "lucide-react";
import { NewsSourceTab } from "./NewsSourceTab";
import { SocialSourceTab } from "./SocialSourceTab";
import { CustomInputTab } from "./CustomInputTab";
import type { NewsSource, SocialPostSource } from "@/types/content-studio";

interface ContentSourceTabsProps {
  selectedNews: NewsSource[];
  selectedSocial: SocialPostSource[];
  customInput: string;
  onAddNews: (source: NewsSource) => void;
  onRemoveNews: (id: string) => void;
  onAddSocial: (source: SocialPostSource) => void;
  onRemoveSocial: (id: string) => void;
  onCustomInputChange: (value: string) => void;
}

export function ContentSourceTabs({
  selectedNews,
  selectedSocial,
  customInput,
  onAddNews,
  onRemoveNews,
  onAddSocial,
  onRemoveSocial,
  onCustomInputChange,
}: ContentSourceTabsProps) {
  return (
    <Tabs defaultValue="news" className="w-full">
      <TabsList className="w-full grid grid-cols-3">
        <TabsTrigger value="news" className="gap-1.5 text-xs">
          <Newspaper className="h-3.5 w-3.5" />
          News {selectedNews.length > 0 && `(${selectedNews.length})`}
        </TabsTrigger>
        <TabsTrigger value="social" className="gap-1.5 text-xs">
          <MessageSquare className="h-3.5 w-3.5" />
          Social {selectedSocial.length > 0 && `(${selectedSocial.length})`}
        </TabsTrigger>
        <TabsTrigger value="custom" className="gap-1.5 text-xs">
          <PenLine className="h-3.5 w-3.5" />
          Custom {customInput.length > 0 && "•"}
        </TabsTrigger>
      </TabsList>

      <TabsContent value="news" className="mt-3">
        <NewsSourceTab selected={selectedNews} onAdd={onAddNews} onRemove={onRemoveNews} />
      </TabsContent>
      <TabsContent value="social" className="mt-3">
        <SocialSourceTab selected={selectedSocial} onAdd={onAddSocial} onRemove={onRemoveSocial} />
      </TabsContent>
      <TabsContent value="custom" className="mt-3">
        <CustomInputTab value={customInput} onChange={onCustomInputChange} />
      </TabsContent>
    </Tabs>
  );
}
